import React from 'react';
import cx from 'classnames';

import css from './checkbox.module.sass';

interface Props {
  name?: string;
  value?: any;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children?: any;
  error?: boolean;
}

export const Checkbox = React.forwardRef<HTMLInputElement, Props>(
  ({ name, value, checked, onChange, children, error = false }, ref) => {
    return (
      <label className={css.root}>
        {children}
        <input
          className={css.input}
          ref={ref}
          name={name}
          value={value}
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
        <span
          className={cx(css.mark, {
            [css.error]: error,
          })}
        />
      </label>
    );
  }
);
